import { useRef, useState, useLayoutEffect } from 'react';

export function useIsOverflowing<T extends HTMLElement>(
  text: string,
): [React.RefObject<T>, boolean] {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  return [ref, isOverflowing] as const;
}
